import React, { useState, useRef, useEffect } from "react";
import { Dimmer } from "../spinner";
import axios from "axios";
import { validaSoloNumero, validaMonto, formatoMonto } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { useParams } from "react-router-dom";
import TablaPlanillaGenerada from "../tablaPlanillasGeneradas";
import TablaDeudaTimbre from "./deudatimbre";

function GenerarDeudaPlanillas() {
  /////#####Declaracion de variables#####/////

  /////variables nativas js
  var parametros = useParams();
  var tipo = parametros.tipo;
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");
  var tipoplanilla =
    tipo === "TF" ? "Timbres Fiscales" : "Guia De Movilización";
  var clave = tipo === "TF" ? "idtipoagente" : "mina";
  var valor = tipo === "TF" ? "4" : true;
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const usuario = JSON.parse(localStorage.getItem("login"));

  /////variables de referencias
  const txtValorUTE = useRef();
  const txtCantidad = useRef();

  /////variables de estados
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [total, setTotal] = useState(0);
  /*     const [values, setValues] = useState({tipo: ''}); */
  const [inhabilitado, setInhabilitado] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [planillas, setPlanillas] = useState([]);

  /////#####funcion para capturar solo numeros#####/////
  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      event.target.value = event.target.value;
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  /*     const onChange = (event) => {
          setValues({...values, [event.target.name]: event.target.value});
        }; */
  /////#####$$$$$#####/////

  /////#####funcion para formatear el monto#####/////
  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  /////#####$$$$$#####/////

  /////#####funcion para blanquear la planilla#####/////
  const blanquearPlanilla = () => {
    txtValorUTE.current.value = "";
    txtCantidad.current.value = "";
  };
  /////#####$$$$$#####/////

  /////#####funcion para agregar la planilla a la tabla#####/////
  const agregarPlanilla = () => {
    const lista = [];
    if (txtCantidad.current.value > 0) {
      for (let i = 0; i < records.length; i++) {
        lista.push(records[i]);
      }
      lista.push({
        idusuariotimbre: idusuario,
        fechageneracion: fechaSistema,
        monto: txtValorUTE.current.value,
        cantidad: txtCantidad.current.value,
        codigoplanilla: tipo,
      });
      setRecords(lista);
      setTotal(total + parseInt(txtCantidad.current.value));
      blanquearPlanilla();
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para validar que no se repita la planilla en la tabla#####/////
  const validarPlanilla = () => {
    if (txtCantidad.current.value !== "") {
      let sigue = true;
      for (let i = 0; i < records.length; i++) {
        if (txtValorUTE.current.value === records[i].monto) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Este registro ya esta cargado en el listado",
            icono: "informacion",
          });
          sigue = false;
        }
      }
      if (sigue) {
        agregarPlanilla();
      }
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para editar la planilla#####/////
  const editarPlanilla = (item) => {
    let element = [];
    if (txtCantidad.current.value === "") {
      for (let i = 0; i < records.length; i++) {
        if (
          records[i].monto == item.monto &&
          records[i].cantidad == item.cantidad
        ) {
          txtValorUTE.current.value = records[i].monto;
          txtCantidad.current.value = records[i].cantidad;
          setTotal(total - parseInt(records[i].cantidad));
        } else {
          element.push(records[i]);
        }
      }
      setRecords(element);
      if (element.length <= 0) {
        setTotal(0);
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Ya esta siendo editado un Registro",
        icono: "informacion",
      });
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para eliminar la planilla#####/////
  const eliminarPlanilla = (item) => {
    let element = [];
    for (let i = 0; i < records.length; i++) {
      if (records[i].monto !== item.monto) {
        element.push(records[i]);
      } else {
        setTotal(total - parseInt(records[i].cantidad));
      }
    }
    setRecords(element);
    if (element.length <= 0) {
      setTotal(0);
    }
  };
  /////#####$$$$$#####/////

  const SeleccionarRegistros = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "planillatimbre";
    let orden = "idplanillatimbre desc";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          const datos = [];
          var tip = "";

          for (let i = 0; i < response.data.length; i++) {
            tip =
              response.data[i].codigoplanilla !== null
                ? response.data[i].codigoplanilla.includes(tipo)
                : false;
            if (tip) {
              datos.push(response.data[i]);
            }
          }

          setPlanillas(datos);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  /////#####proceso para generar las planillas#####/////
  const procesarRegistro = (body) => {
    setActivate(true);
    let endpoint = "";
    endpoint = `${op.conexion}/api/timbres/actualizarplanillas`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.respuesta > 0) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: `${response.data.respuesta} Planillas Generadas Correctamente.`,
              icono: "exito",
            });
            SeleccionarRegistros();
          }
          setActivate(false);
          setRecords([]);
          setTotal(0);
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  /////#####$$$$$#####/////

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  /////#####funcion para generar las planillas#####/////
  const generarPlanillas = () => {
    const element = [];
    for (let i = 0; i < records.length; i++) {
      for (let j = 0; j < parseInt(records[i].cantidad); j++) {
        element.push({
          idusuariotimbre: records[i].idusuariotimbre,
          fechageneracion: records[i].fechageneracion,
          monto: parseFloat(
            records[i].monto.trim().replace(/\./g, "").replace(",", ".")
          ),
          codigoplanilla: records[i].codigoplanilla,
        });
      }
    }
    let body = {
      planillas: element,
    };

    if (element.length > 0) {
      procesarRegistro(body);
    }
  };
  /////#####$$$$$#####/////

  useEffect(() => {
    SeleccionarRegistros();
  }, []);

  return (
    <div className="container-fluid px-3 py-3">
      <ul className="nav mb-3 h-25" id="ex-with-icons" role="tablist">
        <li className="nav-item" role="presentation">
          <a
            className="nav-link text-dark rounded"
            style={{ backgroundColor: "#25d366" }}
            id="ex-with-icons-tab-1"
            data-mdb-toggle="tab"
            href="#ex-with-icons-tabs-1"
            role="tab"
            aria-controls="ex-with-icons-tabs-1"
            aria-selected="true"
          >
            <i className="fas fa-chart-pie fa-fw me-2" />
            Deuda {tipoplanilla}
          </a>
        </li>
      </ul>
      <div className="tab-content" id="ex-with-icons-content">
        <div
          className="tab-pane fade show active"
          id="ex-with-icons-tabs-1"
          role="tabpanel"
          aria-labelledby="ex-with-icons-tab-1"
        >
          <TablaDeudaTimbre tipo={tipo} />
        </div>
      </div>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
}

export default GenerarDeudaPlanillas;

/////////////#####$$$$$#####/////////////////
/////#####Generar Planillas#####/////////
/////#####Programador: Cesar Ratia#####/////
/////#####Empresa: Sygre.ca#####///////////
///////////#####$$$$$#####////////////////



// WEBPACK FOOTER //
// ./src/components/timbres/generarDeudaPlanillas.js